<template>
  <span class="ml-auto text-xs tracking-widest">
    <slot />
  </span>
</template>
